import styled from 'styled-components'
import { FlexContainer } from '../common/Wrappers/Containers'

export const MenuHeader = styled(FlexContainer)`
  padding: 24px;
`
